import React from "react";
import { Link } from "react-router-dom";
import { Header as SiteHeader } from "./Header";
import BottomNav from "./BottomNav";
import Footer from "./Footer";
import ChatWidget from "./ChatWidget";
import PWAInstallPrompt from "./PWAInstallPrompt";
import { Toaster } from "sonner";
import { ArrowLeft } from "lucide-react";

/* Layout globale dell'app.
   - Su mobile: header minimale + bottom nav.
   - Su desktop: header classico full con menu. */
export const AppLayout = ({ children, pageTitle, showBack = false, backTo = "/" }) => {
    return (
        <div className="min-h-screen bg-white font-sans flex flex-col" data-testid="app-layout">
            {/* Header desktop */}
            <div className="hidden md:block sticky top-0 z-40">
                <SiteHeader />
            </div>

            {/* Header mobile compatto */}
            <MobileHeader pageTitle={pageTitle} showBack={showBack} backTo={backTo} />

            <main
                className="flex-1"
                style={{ paddingBottom: "calc(4rem + env(safe-area-inset-bottom))" }}
            >
                {children}
                <Footer />
            </main>

            <BottomNav />
            <ChatWidget />
            <PWAInstallPrompt />

            <Toaster
                position="top-right"
                richColors
                toastOptions={{
                    style: {
                        borderRadius: "12px",
                        fontFamily: "'Manrope', sans-serif",
                    },
                }}
            />
        </div>
    );
};

const MobileHeader = ({ pageTitle, showBack, backTo }) => (
    <header
        data-testid="mobile-header"
        className="md:hidden sticky top-0 z-30 bg-white border-b border-gray-100 shadow-sm"
        style={{ paddingTop: "env(safe-area-inset-top)" }}
    >
        <div className="flex items-center h-[7rem] px-3 gap-3">
            {showBack ? (
                <Link
                    to={backTo}
                    data-testid="mobile-back"
                    className="w-10 h-10 flex items-center justify-center rounded-full bg-nsp-green-50 text-nsp-green hover:bg-nsp-green-100 active:scale-95 transition-all"
                    aria-label="Indietro"
                >
                    <ArrowLeft className="w-4 h-4" strokeWidth={2.5} />
                </Link>
            ) : (
                <Link to="/" className="flex items-center gap-2" aria-label="Home NSP">
                    <img src="/nsp-logo.png" alt="NSP" className="h-[6.5rem] w-[6.5rem] object-contain" />
                </Link>
            )}
            <div className="flex-1 min-w-0">
                <div className="font-display uppercase tracking-tight text-nsp-green text-[18px] leading-none truncate">
                    {pageTitle || "NSP Noleggio"}
                </div>
                {!pageTitle && (
                    <div className="text-[10px] text-gray-400 uppercase tracking-widest mt-0.5">
                        BigMat Ediltutto
                    </div>
                )}
            </div>
            <a
                href="tel:+393272237610"
                data-testid="mobile-header-phone"
                className="w-12 h-12 flex items-center justify-center rounded-full bg-nsp-green text-nsp-yellow hover:bg-nsp-green-dark active:scale-95 transition-all shadow-[0_6px_18px_rgba(10,59,37,0.35)] ring-2 ring-white/60"
                aria-label="Chiama NSP"
            >
                <svg viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor">
                    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                </svg>
            </a>
        </div>
    </header>
);

export default AppLayout;
